import { api } from "api/api";
import { endpoints } from "api/endpoints";

export const GetLocationByDeep = (data) =>
  api.get(endpoints.Location.GetLocationsByDeep(data));

export const GetLocationChildById = (data) =>
  api.get(endpoints.Location.GetChildsById(data));
